// @flow
import type { StrictStringMap } from '@rover/react-lib/types';

import I18N_FORMAT_MAP from '@rover/design-system/style-dictionary/build/es6/i18nFormatMap.constants';
import generateExternalFormatMap from './generateExternalFormatMap';
import generateFormatMapForLang from './generateFormatMap';
import getLocalizedFormatContextless from './getLocalizedFormatContextless';

const getExternalFormatMap = (language: string): StrictStringMap =>
  generateExternalFormatMap(getLocalizedFormatContextless, language);

const getDateTimeFormatMapForLang = (language: string): StrictStringMap =>
  generateFormatMapForLang(getLocalizedFormatContextless, language);

export {
  getDateTimeFormatMapForLang as default,
  getLocalizedFormatContextless as getLocalizedFormat,
  getExternalFormatMap,
  I18N_FORMAT_MAP,
};



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/datetimeContextless.js